import { Star } from "lucide-react";

export function Stars({ value = 0, onChange, size = 20, className = "", testIdPrefix }) {
  const interactive = typeof onChange === "function";
  return (
    <div className={`inline-flex items-center gap-1 ${className}`} role={interactive ? "radiogroup" : undefined}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= value;
        const common = {
          width: size,
          height: size,
          className: `transition-colors ${filled ? "fill-[color:var(--gold)] text-[color:var(--gold)]" : "text-[color:var(--rule)]"}`,
        };
        return interactive ? (
          <button
            type="button"
            key={n}
            onClick={() => onChange(n)}
            aria-label={`${n} star${n > 1 ? "s" : ""}`}
            className="p-0.5 hover:scale-110 transition-transform"
            data-testid={testIdPrefix ? `${testIdPrefix}-${n}` : undefined}
          >
            <Star {...common} />
          </button>
        ) : (
          <Star key={n} {...common} />
        );
      })}
    </div>
  );
}
